define([
        'components/dropdown',
        'core/utilities'
    ],
    function(DD, utilities) {
        let nodes = {
            form: document.querySelector("#form-signup  "),
            firstName: document.querySelector("#id_first_name"),
            firstNameError: document.querySelector(".error.first-name"),
            lastName: document.querySelector("#id_last_name"),
            lastNameError: document.querySelector(".error.last-name"),
            email: document.querySelector("#id_email_address"),
            emailError: document.querySelector(".error.email"),
            title: document.querySelector("#id_professional_title"),
            titleError: document.querySelector(".error.title"),
            company: document.querySelector("#id_company_name"),
            companyError: document.querySelector(".error.company"),
            password1: document.querySelector("#id_password1"),
            password2: document.querySelector("#id_password2"),
            passwordError: document.querySelector(".error.password1"),
            passwordError2: document.querySelector(".error.password2"),
            regionSelector: document.querySelector("#regionSelector"),
            regionSelectorWrap: document.querySelector(".region-selector"),
        };


        let validationConfigs = [
            {
                input: nodes.firstName,
                errorNode: nodes.firstNameError,
                validations: ["hasValue", "alphaNumeric"],
            },
            {
                input: nodes.lastName,
                errorNode: nodes.lastNameError,
                validations: ["hasValue", "alphaNumeric"],
            },
            {
                input: nodes.email,
                errorNode: nodes.emailError,
                validations: ["email", "hasValue"],
            },
            {
                input: nodes.title,
                errorNode: nodes.titleError,
                validations: ["hasValue", "alphaNumeric"],  
            },
            {
                input: nodes.company,
                errorNode: nodes.companyError,
                validations: ["hasValue", "alphaNumeric"],  
            },
            {
                input: nodes.password1,
                input2: nodes.password2,
                errorNode: nodes.passwordError,
                validations: ["passwordsMatch", "hasValue"],  
            },
            {
                input: nodes.password2,
                errorNode: nodes.passwordError2,
                validations: ["hasValue"],  
            },
        ];

        handleRegion = (region) => {
            nodes.form.setAttribute("action", `https://app.smileback.${region}/signup/`);
        }

        return {
            init: function () {
                let saveButton = document.querySelector(".submit");
                let form = document.querySelector("form");

                DD(nodes.regionSelectorWrap, (value) => { 
                    handleRegion(value);
                });

                saveButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    let formIsValid = utilities.validateForm(validationConfigs);

                    if(formIsValid) {
                        saveButton.classList.add("loading");
                        grecaptcha.execute(); // this will submit the form
                    }
                })
            }
        };
    }
);
